import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "./features/auth/authApi";
import authReducer from "./features/auth/authSlice";
import { categoryApi } from "./features/category/categoryApi";
import { subjectApi } from "./features/subject/subjectApi";
import { blogApi } from "./features/blog/blogApi";
import { blogTagApi } from "./features/blog/blogTagApi";
import { artsyProductApi } from "./features/artsy-product/artsyProductApi";
import { tagsApi } from "./features/tags/tagsApi";
import { shippingApi } from "./features/shipping/shippingApi";
import { ordersApi } from "./features/orders/ordersApi";
import { usersApi } from "./features/users/usersApi";
import { customPortraitApi } from "./features/custom-portraits/customPortraitApi";
import { settingsApi } from "./features/settings/settingsApi";
import { contactsApi } from "./features/contacts/contactsApi";
import { finerworksApi } from "./features/finerworks/finerworksApi";
import { couponApi } from "./features/coupons/couponApi";


export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [subjectApi.reducerPath]: subjectApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [blogTagApi.reducerPath]: blogTagApi.reducer,
    [artsyProductApi.reducerPath]: artsyProductApi.reducer,
    [tagsApi.reducerPath]: tagsApi.reducer,
    [shippingApi.reducerPath]: shippingApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [customPortraitApi.reducerPath]: customPortraitApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [contactsApi.reducerPath]: contactsApi.reducer,
    [finerworksApi.reducerPath]: finerworksApi.reducer,
    [couponApi.reducerPath]: couponApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      categoryApi.middleware,
      subjectApi.middleware,
      blogApi.middleware,
      blogTagApi.middleware,
      artsyProductApi.middleware,
      tagsApi.middleware,
      shippingApi.middleware,
      ordersApi.middleware,
      usersApi.middleware,
      customPortraitApi.middleware,
      settingsApi.middleware,
      contactsApi.middleware,
      finerworksApi.middleware,
      couponApi.middleware
    ),

});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
